// @ts-nocheck
import { MultilineText } from "@app/components/core/MultilineText/MultilineText"
import CashregisterUtilitiesModal from "@app/modals/CashregisterUtilitiesModal/CashregisterUtilitiesModal"
import { appStore } from "@app/store/store"
import { getUrl } from "@app/utils/htmlUtils"
import { ModalHandler, useModal } from "@tecreation/funnel-components"
import { ResponseError } from "@tecreation/js-state-react"
import React from "react"
import * as PACKAGE from "../../../package.json"
import "./ErrorBoundary.css"
var version = PACKAGE.version

const ErrorModalButton = () => {
	const { showModal } = useModal()

	return (
		<div
			className="mb-4 text-center semibold clickable flex flex-center"
			onClick={() => {
				showModal(CashregisterUtilitiesModal)
			}}
		>
			<div className="border px-4 py-2 color-bg-secondary-700">
				<span className="color-fg-white">OPEN OPTIONS</span>
			</div>
		</div>
	)
}

const detectDeviceType = () => (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent) ? "Mobile" : "Desktop")

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props)
		this.state = { hasError: false, errors: [] }
	}

	componentDidCatch(error, errorInfo) {
		this.setState(state => ({
			hasError: true,
			errors: [
				...(state.errors || []),
				{
					error,
					errorInfo,
				},
			],
		}))

		let uri = getUrl()
		let message = error.message,
			body,
			db = false,
			stackTrace = error.stack

		if (error instanceof ResponseError) {
			body = {
				ApplicationVersion: version,
				Endpoint: error.response.url,
				StatusCode: error.response.status,
				params: error.params,

				Body: error.sendedBody,
				Token: error.response.data.traceToken,
				Response: error.response.data,
			}

			message = error.response.data.errorMessage || error.message
		} else {
			body = {
				ApplicationVersion: version,
			}
		}

		body.userAgent = window.navigator.userAgent

		body.device = detectDeviceType()

		body = JSON.stringify(body, null, 2)

		let type = appStore.get("core.kioskMode") ? "KIOSK" : appStore.get("core.employeeMode") ? "EMPLOYEE" : "FUNNEL"
		message = type + ";" + message

		fetch("/api/connector/error/trace", {
			method: "POST",
			headers: {
				apiKey: appStore.get("settings.connectorKey"),
				"content-type": "application/json; charset=utf-8",
				Authorization: "Bearer " + appStore.get("core.accessToken"),
			},
			body: JSON.stringify({
				uri,
				message,
				body,
				db,
				stackTrace,
				localStorage: localStorage,
			}),
		})

		if (errorInfo?.componentStack) {
			fetch("/api/connector/error/trace", {
				method: "POST",
				headers: {
					apiKey: appStore.get("settings.connectorKey"),
					"content-type": "application/json; charset=utf-8",
					Authorization: "Bearer " + appStore.get("core.accessToken"),
				},
				body: JSON.stringify({
					uri,
					message: type + ";" + "RenderFailure" + ";" + (errorInfo.message || error.message),
					body,
					db,
					stackTrace: errorInfo?.componentStack,
				}),
			})
		}
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="p-6 errorBoundary">
					{appStore.get("core.employeeMode") && (
						<ModalHandler>
							<ErrorModalButton />
						</ModalHandler>
					)}

					<h1 className="text-center semibold">Something went wrong!</h1>
					<h3 className="text-center semibold">Please provide the stacktrace to us, so we can search for the error.</h3>
					<h3 className="text-center semibold">Version: {version}</h3>

					{this.state.errors.map(({ error, errorInfo }, index) => {
						return (
							<div style={{ backgroundColor: "rgba(206, 17, 38, 0.1)", color: "rgb(252, 207, 207)", letterSpacing: "2px" }} className="p-4 mt-5" key={index}>
								<h3 className="mb-3">ERROR</h3>
								<div>
									{error instanceof ResponseError ? (
										<div>
											<div className="flex">
												<div style={{ width: "150px" }}>Endpoint:</div>
												<div>{error.response.url}</div>
											</div>
											<div className="flex">
												<div style={{ width: "150px" }}>StatusCode:</div>
												<div>{error.response.status}</div>
											</div>
											{error.params && (
												<div className="flex">
													<div style={{ width: "150px" }}>Parameters:</div>
													<div>{error.params}</div>
												</div>
											)}
											{error.sendedBody && (
												<div className="flex">
													<div style={{ width: "150px" }}>Body:</div>
													<div>
														<MultilineText>{JSON.stringify(error.sendedBody, null, 2)}</MultilineText>
													</div>
												</div>
											)}

											{error.response.data.traceToken && (
												<div className="flex">
													<div style={{ width: "150px" }}>ErrorMessage:</div>
													<div>{error.response.data.errorMessage}</div>
												</div>
											)}
											{error.response.data.traceToken && (
												<div className="flex">
													<div style={{ width: "150px" }}>TraceToken:</div>
													<div>{error.response.data.traceToken}</div>
												</div>
											)}
											<div className="flex">
												<div style={{ width: "150px" }}>Response:</div>
												<div>
													<MultilineText>{JSON.stringify(error.response.data, null, 2)}</MultilineText>
												</div>
											</div>
										</div>
									) : (
										<div>
											<MultilineText>{error.message}</MultilineText>
										</div>
									)}
								</div>

								<div className="mt-5 f-4">
									<h3 className="mb-3">Error Stacktrace</h3>
									<MultilineText>{error.stack}</MultilineText>
								</div>

								<div className="mt-5 f-4">
									<h3 className="mb-3">Component Stacktrace</h3>
									<MultilineText>
										{error.toString()}
										{errorInfo.componentStack}
									</MultilineText>
								</div>
							</div>
						)
					})}
				</div>
			)
		}

		return this.props.children
	}
}
